<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="550px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit($event)">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Dividend') }}</span>
            </v-layout>
          </h3>

          <v-spacer />

          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout row wrap>
            <v-flex xs12 pa-2 ma-2 white>
              Income After Tax: <strong>{{ income.income_after_tax | currency }}</strong>
            </v-flex>
            <v-flex xs12 pa-2 ma-2 white>
              Total Share Number: <strong>{{ income.total_share_number | currency }}</strong>
            </v-flex>
            <v-flex xs12 pa-2 ma-2 white>
              Share Profit Amount: <strong>{{ income.share_profit_amount | currency }}</strong>
            </v-flex>

            <v-flex xs12 pa-2>
              <v-menu v-model="dateMenu" full-width max-width="290" :close-on-content-click="false">
                <v-text-field
                  slot="activator"
                  :value="form.dividend_date"
                  :label="`${$t('Dividend Date')} *`"
                  prepend-inner-icon="event"
                  box
                  readonly
                  hide-details
                  name="dividend_date"
                  background-color="white"
                  autocomplete="off"
                  :error="errors.has('dividend_date')"
                  v-validate="'required|date_format:yyyy-MM-dd'"
                />
                <v-date-picker @change="dateMenu = false" v-model="form.dividend_date" />
              </v-menu>
            </v-flex>

            <v-flex xs12 pa-2>
              <v-text-field
                v-model.number="form.share_profit_amount"
                :label="`${$t('Share Profit Amount')} *`"
                name="share_profit_amount"
                box
                readonly
                hide-details
                background-color="white"
                :error="errors.has('share_profit_amount')"
                v-validate="'required|decimal'"
              />
            </v-flex>

            <v-flex xs12 pa-2>
              <v-text-field
                v-model.number="form.total_dividend_amount"
                :label="`${$t('Dividend Amount')} *`"
                name="total_dividend_amount"
                box
                hide-details
                background-color="white"
                :error="errors.has('total_dividend_amount')"
                v-validate="'required|decimal:3|min_value:0|max_value:' + income.income_after_tax"
                data-vv-delay="1000"
                @input="calculateShareProfitAmount()"
              />
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'add-component',
  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      dateMenu: false,
      form: {
        dividend_date: '',
        share_profit_amount: 0,
        total_dividend_amount: 0
      },
      keepForm: false
    }
  },

  computed: {
    ...mapGetters({
      income: 'dividends/getIncomeAfterTax'
    })
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addDividend: 'dividends/addDividend'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.dividend_date = this.$moment()
        .format()
        .substr(0, 10)
      this.form.share_profit_amount = this.income.share_profit_amount
      this.form.total_dividend_amount = this.income.income_after_tax

      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('dividend-focus-me').focus()
      })
    },

    calculateShareProfitAmount() {
      this.form.share_profit_amount = Number(this.form.total_dividend_amount / this.income.total_share_number).toFixed(
        2
      )
    },

    validateBeforeSubmit(event) {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true

            let formData = new FormData(event.target)

            // for (let pair of formData.entries()) {
            //   console.warn(`${pair[0]}: ${pair[1]}`)
            // }

            this.addDividend(formData)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
                this.fetchLastDollarPrice()
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
